import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import {
  FaHtml5,
  FaCss3Alt,
  FaJs,
  FaReact,
  FaNodeJs,
  FaGitAlt,
  FaFigma,
  FaGithub,
} from "react-icons/fa";
import {
  SiExpress,
  SiMongodb,
  SiVisualstudiocode,
  SiKotlin,
  SiFlutter,
  SiDart,
  SiTailwindcss,
  SiPrisma,
  SiNextdotjs,
  SiNestjs,
  SiSupabase,
  SiFirebase
} from "react-icons/si";
import { BiLogoVisualStudio } from "react-icons/bi";

const Technologies = () => {
  return (
    <StyledTechnologies
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
    >
      <h2>TECHNOLOGIES</h2>
      <motion.div
        className="section-bar"
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        viewport={{ once: true }}
      />

      <div className="tech-grid">
        {/* Frontend */}
        <div className="tech-category">
          <h3>Frontend</h3>
          <div className="tech-items">
            <div className="tech-item">
              <motion.div
                className="tech-icon html"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
              >
                <FaHtml5 />
              </motion.div>
              <p>HTML5</p>
            </div>
            <div className="tech-item">
              <motion.div
                className="tech-icon css"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <FaCss3Alt />
              </motion.div>
              <p>CSS3</p>
            </div>
            <div className="tech-item">
              <motion.div
                className="tech-icon js"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.3 }}
              >
                <FaJs />
              </motion.div>
              <p>JavaScript</p>
            </div>
            <div className="tech-item">
              <motion.div
                className="tech-icon react"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.4 }}
              >
                <FaReact />
              </motion.div>
              <p>React.js</p>
            </div>
            <div className="tech-item">
              <motion.div 
                className="tech-icon nextjs"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.45 }}
              >
                <SiNextdotjs />
              </motion.div>
              <p>Next.js</p>
            </div>
            <div className="tech-item">
              <motion.div
                className="tech-icon tailwind"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.5 }}
              >
                <SiTailwindcss />
              </motion.div>
              <p>Tailwind CSS</p>
            </div>
          </div>
        </div>

        {/* Backend */}
        <div className="tech-category">
          <h3>Backend</h3>
          <div className="tech-items">
            <div className="tech-item">
              <motion.div
                className="tech-icon node"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.55 }}
              >
                <FaNodeJs />
              </motion.div>
              <p>Node.js</p>
            </div>
            <div className="tech-item">
              <motion.div
                className="tech-icon express"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.6 }}
              >
                <SiExpress />
              </motion.div>
              <p>Express.js</p>
            </div>
            <div className="tech-item">
              <motion.div
                className="tech-icon mongodb"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.65 }}
              >
                <SiMongodb />
              </motion.div>
              <p>MongoDB</p>
            </div>
            <div className="tech-item">
              <motion.div 
                className="tech-icon nestjs"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.7 }}
              >
                <SiNestjs />
              </motion.div>
              <p>NestJS</p>
            </div>
            <div className="tech-item">
              <motion.div 
                className="tech-icon prisma"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.75 }}
              >
                <SiPrisma />
              </motion.div>
              <p>Prisma</p>
            </div>
            <div className="tech-item">
              <motion.div 
                className="tech-icon firebase"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.8 }}
              >
                <SiFirebase />
              </motion.div>
              <p>Firebase</p>
            </div>
            <div className="tech-item">
              <motion.div 
                className="tech-icon supabase"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.8 }}
              >
                <SiSupabase />
              </motion.div>
              <p>Supabase</p>
            </div>
          </div>
        </div>
        
        {/* Tools */}
        <div className="tech-category">
          <h3>Tools</h3>
          <div className="tech-items">
            <div className="tech-item">
              <motion.div
                className="tech-icon git"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.85 }}
              >
                <FaGitAlt />
              </motion.div>
              <p>Git</p>
            </div>
            <div className="tech-item">
              <motion.div
                className="tech-icon figma"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.9 }}
              >
                <FaFigma />
              </motion.div>
              <p>Figma</p>
            </div>
            <div className="tech-item">
              <motion.div
                className="tech-icon vscode"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.95 }}
              >
                <BiLogoVisualStudio />                 
            </motion.div>
              <p>VS Code</p>
            </div>
            <div className="tech-item">
              <motion.div
                className="tech-icon github"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 1.0 }}
              >
                <FaGithub />
              </motion.div>
              <p>GitHub</p>
            </div>
          </div>
        </div>

        {/* Mobile Development */}
        <div className="tech-category">
          <h3>Mobile Development</h3>
          <div className="tech-items">
            <div className="tech-item">
              <motion.div
                className="tech-icon kotlin"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 1.05 }}
              >
                <SiKotlin />
              </motion.div>
              <p>Kotlin</p>
            </div>
            <div className="tech-item">
              <motion.div
                className="tech-icon reactnative"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 1.1 }}
              >
                <FaReact />
              </motion.div>
              <p>React Native</p>
            </div>
            <div className="tech-item">
              <motion.div
                className="tech-icon flutter"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 1.15 }}
              >
                <SiFlutter />
              </motion.div>
              <p>Flutter</p>
            </div>
            <div className="tech-item">
              <motion.div
                className="tech-icon dart"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 1.2 }}
              >
                <SiDart />
              </motion.div>
              <p>Dart</p>
            </div>
          </div>
        </div>
      </div>
    </StyledTechnologies>
  );
};

const StyledTechnologies = styled(motion.div)`
  width: 100%;
  text-align: center;

  h2 {
    font-size: 1.5rem;
    color: var(--primary-text);
    margin-bottom: 1rem;
    letter-spacing: 0.15em;
    font-weight: 700;
  }

  .section-bar {
    height: 2px;
    width: 60px;
    margin: 0 auto 3rem;
    background: var(--accent-color, #61DAFB);
    border-radius: 1px;
    transform-origin: center;
  }

  .tech-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
    justify-content: center;

    .tech-category {
      flex: 1;
      min-width: 280px;
      text-align: left;

      h3 {
        font-size: 1.2rem;
        color: var(--primary-text);
        margin-bottom: 1rem;
        font-weight: 600;
      }

      .tech-items {
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;

        .tech-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 0.5rem;
          text-align: center;

          .tech-icon {
            width: 60px;
            height: 60px;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: transparent;
            color: var(--primary-text);
            font-weight: 600;
            font-size: 2rem;
            transition: all 0.3s ease;
            border: 1px solid rgba(var(--border-color-rgb), 0.3);
            position: relative;
            overflow: hidden;

            &::before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background: radial-gradient(circle at center, rgba(var(--vibrant-rgb), 0.08) 0%, rgba(var(--vibrant-rgb), 0) 70%);
              opacity: 0;
              transition: opacity 0.3s ease;
            }

            svg {
              font-size: 1.8rem;
              transition: transform 0.3s ease;
            }

            &:hover {
              transform: translateY(-5px);
              border-color: var(--vibrant);
              box-shadow: 0 8px 16px rgba(var(--vibrant-rgb), 0.15), 0 0 20px rgba(var(--vibrant-rgb), 0.3);
              background: linear-gradient(135deg, rgba(74, 91, 239, 0.1) 0%, rgba(143, 60, 218, 0.1) 100%);
              
              &::before {
                opacity: 1;
              }
              
              svg {
                transform: scale(1.15);
                color: var(--vibrant);
                filter: drop-shadow(0 0 5px rgba(var(--vibrant-rgb), 0.4));
              }
            }
          }

          p {
            font-size: 0.9rem;
            color: var(--secondary-text);
            margin: 0;
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    .tech-grid .tech-category {
      min-width: 200px;
    }

    .tech-grid .tech-category .tech-items .tech-item .tech-icon {
      width: 50px;
      height: 50px;
    }
  }
`;

export default Technologies;